import { progressAnatomy } from "@chakra-ui/anatomy";
import { ComponentStyleConfig, PartsStyleObject } from "@chakra-ui/react";

const colors: Record<
  string,
  PartsStyleObject<typeof progressAnatomy> | undefined
> = {
  lightGreen: {
    track: {
      bg: "gray.100",
    },
    filledTrack: {
      bg: "primary.300",
    },
  },
};

const ProgressTheme: ComponentStyleConfig = {
  baseStyle: ({ colorScheme }) => ({
    track: {
      ...colors[colorScheme]?.track,
      borderRadius: "8px",
    },
    filledTrack: {
      ...colors[colorScheme]?.filledTrack,
      borderRadius: "4px",
    },
  }),
  sizes: {
    xs: {
      track: {
        height: "5px",
        borderRadius: "2.5px",
      },
      filledTrack: {
        borderRadius: "2.5px",
      },
    },
  },
};

export default ProgressTheme;
